import React, { useMemo } from 'react';
import { Box, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { CalendarMonth, ArrowUpwardRounded, ArrowDownwardRounded, FormatListNumberedRounded } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';

const SORT_BY = [
  { value: 'id', label: 'ID', icon: <FormatListNumberedRounded fontSize="small" /> },
  { value: 'startDate', label: 'Start Date', icon: <CalendarMonth fontSize="small" /> },
  { value: 'entryDate', label: 'Entry Date', icon: <CalendarMonth fontSize="small" /> },
];

const JobsSortToggle = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const values = useMemo(
    () => ({
      SortBy: searchParams.get('SortBy') || 'startDate',
      SortOrder: searchParams.get('SortOrder') || 'asc',
    }),
    [searchParams]
  );

  const setParam = (k, v) => {
    const next = new URLSearchParams(searchParams);
    if (v === '' || v == null) next.delete(k); else next.set(k, v);
    next.set('PageNumber', '0');
    setSearchParams(next);
  };

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.25, alignItems: 'center' }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <ToggleButtonGroup
          value={values.SortBy}
          exclusive
          onChange={(e, val) => { if (val) setParam('SortBy', val); }}
          size="small"
          sx={{ flexWrap: 'wrap', gap: 1 }}
        >
          {SORT_BY.map((s) => (
            <ToggleButton
              key={s.value}
              value={s.value}
              sx={{
                textTransform: 'none',
                fontWeight: 700,
                borderRadius: 2,
                px: 1,
                color: values.SortBy === s.value ? 'primary.main' : 'text.primary',
              }}
            >
              <Stack direction="row" spacing={0.5} alignItems="center">
                {s.icon}
                <span>{s.label}</span>
              </Stack>
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Stack>

      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>|</Typography>
        <ToggleButtonGroup
          value={values.SortOrder}
          exclusive
          onChange={(e, val) => { if (val) setParam('SortOrder', val); }}
          size="small"
          sx={{ gap: 1 }}
        >
          <ToggleButton value="asc" sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2, px: 1 }}>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <ArrowUpwardRounded fontSize="small" />
              <span>Asc</span>
            </Stack>
          </ToggleButton>
          <ToggleButton value="desc" sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2, px: 1 }}>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <ArrowDownwardRounded fontSize="small" />
              <span>Desc</span>
            </Stack>
          </ToggleButton>
        </ToggleButtonGroup>
      </Stack>
    </Box>
  );
};

export default JobsSortToggle;
